import React from 'react';
import './cepcidocs.css';

const PdfViewer = () => {
  const isMobile = window.innerWidth <= 768; 

  return (
    <div align='center' className="pdf-viewer-container">
      <h2 className="pdf-viewer-title">Programa Anual de Trabajo 2024</h2>
      {isMobile ? (
       
        <div className="pdf-viewer-mobile">
          <a
            href={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Prog_Anual_Trab_2024.pdf`}
            download
            className="pdf-viewer-download"
          >
            Descargar PDF
          </a>
        </div>
      ) : (
        // Si no es un dispositivo móvil, mostrar el visor de PDF en un iframe
        <div className="pdf-viewer-wrapper">
          <iframe
            src={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Prog_Anual_Trab_2024.pdf`}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;